import OfflinePvp from './OfflinePvp';
import gameRule from './gameRule';

OfflinePvp.gameRule = gameRule;

export default OfflinePvp;



// WEBPACK FOOTER //
// ./src/games/OfflinePvp/index.js